import { matchRoutes } from 'react-router';
import type { RouteObject } from 'react-router';
import { ShellLayout } from './ShellLayout';
import { RouteErrorBoundary } from '../components/common/RouteErrorBoundary';

export function createRoutes(): RouteObject[] {
  return [
    {
      element: <ShellLayout />,
      errorElement: <RouteErrorBoundary />,
      children: [
        {
          index: true,
          lazy: () => import('../routes/home'),
        },
        { path: 'corpus', lazy: () => import('../routes/landing') },
        { path: 'quality', lazy: () => import('../routes/quality') },
        { path: 'about', lazy: () => import('../routes/about') },
        {
          path: 'search',
          lazy: () => import('../routes/search'),
        },
        {
          path: 'coverage',
          lazy: () => import('../routes/coverage'),
        },
        {
          path: 'work/:workId',
          lazy: () => import('../routes/work'),
          children: [
            {
              index: true,
              lazy: () => import('../routes/work.timeline'),
            },
            {
              path: 'graph',
              lazy: () => import('../routes/work.graph'),
            },
            {
              path: 'provisions',
              lazy: () => import('../routes/work.provisions'),
            },
            {
              path: 'diff',
              lazy: () => import('../routes/work.diff'),
            },
            {
              path: 'blame',
              lazy: () => import('../routes/work.blame'),
            },
            {
              path: 'ask',
              lazy: () => import('../routes/work.ask'),
            },
          ],
        },
        {
          path: '*',
          lazy: () => import('../routes/not-found'),
        },
      ],
    },
  ];
}

export async function loadPageRoutes(url: string): Promise<RouteObject[]> {
  const routes = createRoutes();
  const matches =
    matchRoutes(routes, new URL(url, 'https://slad-sl.pages.dev').pathname) || [];
  await Promise.all(
    matches.map(async ({ route }) => {
      if (typeof route.lazy === 'function') {
        const resolved = await route.lazy();
        Object.assign(route, resolved, { lazy: undefined });
      }
    }),
  );
  return routes;
}
